<a role="button" tabindex="0" class="appointment-slot appointment-slot-more" data-appointment-booking-provider-widget-behaviour="open-appointment-modal"
   data-analytics-element="provider-widget-more-slots" data-analytics-interaction="click" data-analytics-value="<%= moment.parseZone(date).format('YYYY-MM-DD') %>">
  <span class="appointment-slot-more__count"><%= I18n.more_appointments.replace('%{count}', total - slots.length) %></span>
  <span class="appointment-slot-more__icon expander-icon"></span>
</a>
